import { useQuery } from "react-query";
import { GetVoucherResponse } from "../../constants/types";
import axios from "../axios";

const queryString = require("query-string");

const handleRequest = async (params?: { ukmId?: number }) => {
    const apiUrl = queryString.stringifyUrl({
        url: "/api/voucher",
        query: {
            ukmId: params?.ukmId,
        },
    });
    const { data } = await axios.get<GetVoucherResponse>(apiUrl);
    return data.data;
};

export default function useVoucher(params?: { ukmId?: number }) {
    return useQuery<GetVoucherResponse["data"]>(
        ["voucher", "list", params],
        () => handleRequest(params),
        { enabled: Boolean(params?.ukmId) },
    );
}
